import { InjectionToken } from '@angular/core';

export type KioskDisplayMode = 'layout' | 'city';

export const KIOSK_EVSE_GRID_APPEARANCE = new InjectionToken<'legacy' | 'current'>('KIOSK_EVSE_GRID_APPEARANCE');
